import React, { useContext } from 'react';
import { Loader } from 'components';
import { ToastContext } from 'contexts';
import { Typography, visuallyHidden } from 'bonfire-kindling';
import axios from 'helpers/axios';
import { PROJECTS_PINNED } from 'constants/apis';
import { Switch, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OpportunitiesCard from './OpportunitiesCard';
import OpportunitiesEmpty from './OpportunitiesEmpty';
import useInfiniteScroll from '../../hooks/useInfiniteScroll';

function OpportunitiesList({
  collection,
  fetchMore,
  hasUserChangedFilter,
  updateProjectFollowingStatus,
  searchKeyword,
  logInToOrganizationDomain,
}) {
  const toastContext = useContext(ToastContext);
  const { t } = useTranslation();
  useInfiniteScroll(fetchMore);
  const follow = projectUUID => {
    const body = {
      ProjectUUID: projectUUID,
    };

    axios
      .post(PROJECTS_PINNED, body)
      .then(() => updateProjectFollowingStatus(projectUUID, true))
      .catch(() => toastContext.triggerToast({}));
  };

  const unfollow = projectUUID => {
    const data = {
      ProjectUUID: projectUUID,
    };

    axios
      .delete(PROJECTS_PINNED, { data })
      .then(() => updateProjectFollowingStatus(projectUUID, false))
      .catch(() => toastContext.triggerToast({}));
  };

  if (!collection || (collection.isLoading && !collection.shouldAppend)) {
    return <Loader variant="puff" isCentered />;
  }

  return (
    <>
      <Switch>
        <Route path="/opportunities/recommended">
          <Typography style={visuallyHidden} component="h2">
            {t('opportunities.screen_reader.recommended')}
          </Typography>
        </Route>
        <Route path="/opportunities/following">
          <Typography style={visuallyHidden} component="h2">
            {t('opportunities.screen_reader.followed')}
          </Typography>
        </Route>
        <Route path="/opportunities/all">
          <Typography style={visuallyHidden} component="h2">
            {t('opportunities.screen_reader.all')}
          </Typography>
        </Route>
      </Switch>
      {collection.data.length === 0 && (
        <OpportunitiesEmpty
          searchKeyword={searchKeyword}
          hasUserChangedFilter={hasUserChangedFilter}
        />
      )}
      {collection.data.map(project => (
        <OpportunitiesCard
          {...project}
          key={project.ProjectUUID}
          toggleIsFollowing={() =>
            project.IsFollowing ? unfollow(project.ProjectUUID) : follow(project.ProjectUUID)
          }
          logInToOrganizationDomain={logInToOrganizationDomain}
        />
      ))}
      {collection.data.length < collection.total && <Loader variant="puff" isCentered />}
    </>
  );
}

export default OpportunitiesList;
